import {Dialog, Pane, Paragraph} from 'evergreen-ui';
import React, {memo, useCallback} from 'react';
import {BehaviorSubject} from 'rxjs';

import {useObservable} from '../../../rxsupport';

type Props = {
    show$: BehaviorSubject<boolean>;
    loading: boolean;
    onConfirmed: () => any;
}

const WIDTH = 600;

export const DeclineOfferConfirmationDialog =
    memo(function DeclineOfferConfirmationDialog({
                                                     show$,
                                                     loading,
                                                     onConfirmed,
                                                 }: Props) {
        const show = useObservable(show$, false);
        const onClose = useCallback(() => {
            show$.next(false);
        }, [show$]);

        return (
            <Dialog
                title="Decline Offer"
                isShown={show}
                width={WIDTH}
                hasClose={false}
                onCloseComplete={onClose}
                contentContainerProps={{
                    textAlign: 'center',
                    justifyContent: 'center'
                }}
                footer={({close}) => (<>
                    {/* minus the default evergreen-ui padding in footer container */}
                    <Pane width={WIDTH - 16 * 2} className="flex justify-center">
                        <button
                            autoFocus
                            className="px-5 py-2 mr-5 focus:outline-none"
                            disabled={loading}
                            onClick={close}
                            style={{
                                backgroundColor: '#FFF',
                                color: '#00AB93',
                                borderColor: '#00AB93',
                                border: '1px solid'
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            className={`px-5 py-2 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                            disabled={loading}
                            onClick={onConfirmed}
                            style={{
                                backgroundColor: '#00AB93',
                                color: '#FFF'
                            }}
                        >
                            Confirm
                        </button>
                    </Pane>
                </>)}
            >
                <Paragraph style={{color: '#707070'}} size={500}>
                    Please confirm that you want to decline this offer. Once its declined it will no longer be available
                    to select and will no longer be displayed
                </Paragraph>

            </Dialog>
        );
    });
